import { render, staticRenderFns } from "./ServerNotification.vue?vue&type=template&id=117728c0"
import script from "./ServerNotification.vue?vue&type=script&lang=js"
export * from "./ServerNotification.vue?vue&type=script&lang=js"
import style0 from "./ServerNotification.vue?vue&type=style&index=0&id=117728c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports